module.exports = __webpack_public_path__ + "static/image/logo-family/logo_gift.png?0232c638";